/* esm.sh - rxjs@7.8.2/dist/esm/internal/scheduler/performanceTimestampProvider */
var e={now(){return(e.delegate||performance).now()},delegate:void 0};export{e as performanceTimestampProvider};
//# sourceMappingURL=performanceTimestampProvider.mjs.map